<template>
    <div>
        <v-dialog v-model="isActive" transition="dialog-bottom-transition" scrollable persistent
            :width="$vuetify.breakpoint.xsOnly ? '99%' : '930px'">
            <v-overlay :value="overlay" :z-index="1000">
                <v-container fluid class="d-flex align-center justify-center">
                    <v-row class="d-flex align-center justify-center">
                        <v-col cols="12" class="text-center">
                            <v-card color="white" class="px-5 py-10 elevation-6">
                                <!-- <v-img src="@/assets/Logo-bt-06.png" width="480" class="animacion-logo"></v-img> -->
                                <v-progress-circular indeterminate size="84" width="10" color="primary"
                                    class="animacion-process ma-5"></v-progress-circular>
                                <v-card-text>
                                    <div class="font-weight-primary primary--text text-center"
                                        :class="($vuetify.breakpoint.xsOnly) ? 'text-h6' : 'text-h5'">
                                        Estamos procesando tu plan de pago.
                                        <br>Por favor, <div class="d-inline font-weight-bold">no cierres la ventana.
                                        </div>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-overlay>
            <v-card class="rounded-0 ma-0 pa-0 dialog-card">
                <v-app-bar color="white" class="rounded-0 sticky-title-bar" flat style="min-height: auto;">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" icon light @click="confirmAndClose(false)">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Cerrar</span>
                    </v-tooltip>
                    <v-toolbar-title class="text-body-1 text-uppercase font-weight-regular primary--text"
                        style="white-space: normal; word-break: break-word;">Financiación de Aportes
                        Mensuales</v-toolbar-title>
                </v-app-bar>
                <v-card flat class="dialog-body-scroll">
                    <v-stepper v-model="step" flat>
                        <v-stepper-header>
                            <v-stepper-step :complete="step > 1" step="1">Simulá tu plan de pago</v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step :complete="step > 2" step="2">Elegí cómo pagar</v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step :complete="step > 3" step="3">Resumen y confirmación</v-stepper-step>
                        </v-stepper-header>
                        <v-stepper-items>
                            <v-stepper-content step="1">
                                <FormSimularPlanPago @siguiente="nextStep"></FormSimularPlanPago>
                            </v-stepper-content>
                            <v-stepper-content step="2">
                                <FormSeleccionarCuenta @siguiente="nextStep" @volver="previousStep">
                                </FormSeleccionarCuenta>
                            </v-stepper-content>
                            <v-stepper-content step="3">
                                <FormResumenConfirmacion @volver="previousStep" @confirmar="confirmAndClose"
                                    @mostrar-overlay="overlay = $event">
                                </FormResumenConfirmacion>
                            </v-stepper-content>
                        </v-stepper-items>
                    </v-stepper>
                </v-card>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import FormSimularPlanPago from '@/components/forms/FormSimularPlanPago.vue';
import FormSeleccionarCuenta from '@/components/forms/FormSeleccionarCuenta.vue';
import FormResumenConfirmacion from '@/components/forms/FormResumenConfirmacion.vue';
import { mapActions } from 'vuex';
export default {
    name: 'DialogoRefinanciacionPP',
    components: {
        FormSimularPlanPago,
        FormSeleccionarCuenta,
        FormResumenConfirmacion
    },
    mounted() {
        //this.obtenerMediosPago()
        this.obtenerParametrosPlanPago()
    },
    data() {
        return {
            isActive: false,
            step: 1,
            overlay: false,
        };
    },
    methods: {
        ...mapActions('mediosDePago', ['obtenerParametrosPlanPago', 'obtenerMediosPago', 'limpiarFlujoPP']),

        nextStep() {
            if (this.step < 3) {
                this.step++;
            } else {
                this.confirmAndClose(true);
            }
        },
        previousStep() {
            if (this.step > 1) {
                this.step--;
            }
        },

        confirmAndClose(result) {
            if (this.callback) {
                this.callback(result);
                this.callback = null;
            }
            this.isActive = false
            this.limpiarFlujoPP()
        },
        abrirDialogo() {
            this.isActive = true;
            return new Promise(resolve => {
                this.callback = resolve;
            });
        },
    }
}

</script>

<style scoped>
.dialog-card {
    max-height: 90vh;
    overflow: hidden;
}

.sticky-title-bar {
    position: sticky;
    top: 0;
    z-index: 10;
}

.dialog-body-scroll {
    max-height: calc(90vh - 64px);
    overflow-y: auto;
}

.dialogo-stepper-content {
    max-height: calc(100vh - 220px);
    overflow-y: auto;
    padding-bottom: 90px;
}
</style>